import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Breadcrumb, Button, Modal } from "react-bootstrap";
import { ROOT_FOLDER } from "../DocumentModal";

const FolderBreadcrumb = ({ t, currentFolder, callbackBreadCrumb }) => {
  const handleClickBreadcrumb = (e, index, id) => {
    e.preventDefault();
    callbackBreadCrumb(index, id);
  };
  return (
    <Breadcrumb className="h6 m-0">
      {currentFolder?.map((folder, index) =>
        index + 1 === currentFolder?.length ? (
          <Breadcrumb.Item key={index} active>
            {folder?.name}
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item
            key={index}
            href="#"
            onClick={(e) => handleClickBreadcrumb(e, index, folder.id)}
          >
            {folder?.name}
          </Breadcrumb.Item>
        )
      )}
    </Breadcrumb>
  );
};

export default withTranslation()(FolderBreadcrumb);
